import React, { useState, useEffect } from 'react';
import {
  Container, MenuItem, FormGroup, TextField, Grid,
} from '@mui/material';
import Autocomplete from '@mui/material/Autocomplete';
import api from '../../services/api';
import { useHistory } from 'react-router-dom';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useDispatch, useSelector } from 'react-redux';
import { setSnackbar } from '../../redux/snackbar';
import { setDisable } from '../../redux/disable';
import { setLoading } from '../../redux/loading';
import SaveButton from '../../components/Buttons/SaveButton';
import Progress from '../../components/Progress';
import { useStyles } from '../../components/Styles';

function Indice() {
  const [open, setOpen] = useState(false);
  const [openError, setOpenError] = useState(false);
  const classes = useStyles();
  const disable = useSelector((state) => state.disable.disable);
  const [parameters, setParameters] = useState([]);
  const [selectedParameters, handleParameters] = useState([]);
  const [openProgress, setOpenProgress] = useState(false);
  const [id, setId] = useState(null);

  const dispatch = useDispatch();
  const history = useHistory();

  useEffect(() => {
    // carrega os dados no seu devido campo caso tenha id, do contrário,
    // carrega o formulário vazio para cadastrar um novo
    async function loadData() {
      setOpenProgress(true);

      const indices_ = await api.get('/configIndices');

      const parameter_ = await api.get('/parameters');
      const ambientParameter = [];

      parameter_.data.map((item) => {
        if (item.hasOptions === false) ambientParameter.push(item);
        return null;
      });

      setParameters(ambientParameter);

      handleParameters(indices_.data.parameter);

      setOpenProgress(false);
    }
    loadData();
  }, []);

  const formik = useFormik({
    initialValues: {
      name: 'Biomassa',
      parameter: '',
    },
    validationSchema: Yup.object({

    }),
    onSubmit: (values) => {
      values.parameter = selectedParameters.id;
      dispatch(setLoading(true));
      request(values);
    },
  });

  async function request(data) {
    // envia os dados para api salvar no banco

    dispatch(setDisable(true));
    try {
      id
        ? await api.put(`/configIndices/${id}`, { ...data }).then((res) => {
          setOpen(true);
        })
        : await api.post('/configIndices', { ...data }).then((res) => {
          setOpen(true);
        });
    } catch (err) {
      setOpenError(true);

      setOpenError(false);
    }
    dispatch(setDisable(false));
    dispatch(setLoading(false));
  }

  const success = () => {
    dispatch(
      setSnackbar(
        true,
        'success',
        'Ação Submetida com Sucesso!',
      ),
    );
    history.push('/report');
  };

  const error = () => {
    dispatch(
      setSnackbar(
        true,
        'error',
        'Erro ao submeter ação! Tente novamente.',
      ),
    );
  };

  return (

    <Container>
      {openProgress ? <Progress /> : null}
      {' '}
      {/** Carregamento circular para o carregamento dos dados */}

      <form className={classes.root} onSubmit={formik.handleSubmit}>
        <h2 className="title">Configuração de Indicadores</h2>

        <FormGroup>
          <TextField
            InputLabelProps={{ style: { pointerEvents: 'auto' } }}
            id="name"
            select
            label={(
              <div>
                Indicador
              </div>
                          )}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            variant="outlined"
            value={formik.values.name}
            name="name"
            as="select"
            error={formik.touched.name && formik.errors.name}
            helperText={
                            formik.touched.name && formik.errors.name && formik.errors.name
                        }
          >
            <MenuItem key={1} value="Biomassa" selected>
              Biomassa
            </MenuItem>
          </TextField>

        </FormGroup>

        <FormGroup>

          <Autocomplete
            noOptionsText="Sem opções"
            fullWidth
            id="parameter"
            options={parameters}
            value={selectedParameters}
            getOptionLabel={(option) => (option.name ? option.name : '')}
            onChange={(_, v) => {
              handleParameters(v);
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
                label="Parâmetro de cálculo"
                placeholder="Parâmetro de cálculo"
              />
            )}
          />

        </FormGroup>

        {open ? success() : null}
        {openError ? error() : null}

        <FormGroup>

          <Grid container direction="row" justifyContent="space-between" alignItems="flex-end" className={classes.root}>

            <Grid item xs>
              <SaveButton disabled={disable} />
            </Grid>
          </Grid>

        </FormGroup>

      </form>
    </Container>
  );
}

export default Indice;
